module.exports = __webpack_public_path__ + "assets/octobre-rose.38410289.svg";